import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link, useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "sr/helpers";
import { RadioInput } from "sr/helpers/ui-components/RadioInput";

export const HireCleaner = () => {
const [registerType, SetRegisterType] = useState('')
    const navigate = useNavigate()
        useEffect(()=>{
    if(registerType==='Company'){
      navigate('/create-company')
    }
    if(registerType==='Individual'){
        navigate('/registerasindividual')
    }
        },[registerType])

  return (
  
<main>
        <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
         
            <div className="h-fit lg:mx-12 block p-6 bg-white border border-gray-border rounded-xl">
              <div className="flex justify-center">
            <Link to="/" className='z-50'>
                        <img width={150} src={toAbsoluteUrl('/media/logos/logo2.png')} alt=''
                            className='bg-white rounded-lg' />
                            </Link>
                            </div>
              <h1 className=" text-xl mt-10">
                <FormattedMessage
                  id="AUTH.REGISTER.BUTTON"
                  defaultMessage="Register"
                />
              </h1>
              <div> 
             <div className='mt-5'>
                                                <p className="mt-10 mb-1 text-gray-700 text-sm ">What are you hiring a cleaner for?</p> 
                                                <div className="flex space-x-6">
                                                       <RadioInput name='Individual' value={'Individual'} label={'My home or apartment'} checked={registerType==='Individual'} onChange={()=> {SetRegisterType('Individual')}}  /> 
                                                       <RadioInput name='Company' value={'Company'} label={'My cleaning business'} checked={registerType==='Company'} onChange={()=> {SetRegisterType('Company')}}  />
                                                                </div></div>
                </div></div>
              </div>

              </main>
  
);
};
